module.exports = __webpack_public_path__ + "static/contatti_small-df5603c9c8b597b992f0631421119d85.jpg";